// get the percent width of a time compared to the total end
export function percentify(time, end) {
  return `${percentifyRaw(time, end)}%`;
}

export function percentifyRaw(time, end) {
  const percent = time / end || 0;

  return (percent >= 1 ? 1 : percent) * 100;
}
